var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.00313C0 7.33646 0.370833 5.80729 1.1125 4.41563C1.85417 3.02396 2.85 1.86979 4.1 0.953125L5.275 2.55313C4.275 3.28646 3.47917 4.21146 2.8875 5.32813C2.29583 6.44479 2 7.66979 2 9.00313H0ZM18 9.00313C18 7.66979 17.7042 6.44479 17.1125 5.32813C16.5208 4.21146 15.725 3.28646 14.725 2.55313L15.9 0.953125C17.15 1.86979 18.1458 3.02396 18.8875 4.41563C19.6292 5.80729 20 7.33646 20 9.00313H18ZM2 18.0031V16.0031H4V9.00313C4 7.61979 4.41667 6.39063 5.25 5.31563C6.08333 4.24063 7.16667 3.53646 8.5 3.20313V2.50313C8.5 2.08646 8.64583 1.73229 8.9375 1.44063C9.22917 1.14896 9.58333 1.00313 10 1.00313C10.4167 1.00313 10.7708 1.14896 11.0625 1.44063C11.3542 1.73229 11.5 2.08646 11.5 2.50313V3.20313C12.8333 3.53646 13.9167 4.24063 14.75 5.31563C15.5833 6.39063 16 7.61979 16 9.00313V16.0031H18V18.0031H2ZM10 21.0031C9.45 21.0031 8.97917 20.8073 8.5875 20.4156C8.19583 20.024 8 19.5531 8 19.0031H12C12 19.5531 11.8042 20.024 11.4125 20.4156C11.0208 20.8073 10.55 21.0031 10 21.0031ZM6 16.0031H14V9.00313C14 7.90313 13.6083 6.96146 12.825 6.17813C12.0417 5.39479 11.1 5.00313 10 5.00313C8.9 5.00313 7.95833 5.39479 7.175 6.17813C6.39167 6.96146 6 7.90313 6 9.00313V16.0031Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushNotification);
export default __webpack_public_path__ + "static/media/push_notification.7986ec4ee01ef118f6179a531db337f5.svg";
export { ForwardRef as ReactComponent };